<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" inline :no-padding="false">
        <cms-component-glyph comp-id="glyph" :component="block.glyph" v-bind="componentProps"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsComponentGlyph from "@components/editor/rendering/components/cms-component-glyph.vue";

// cms-block-glyph #hot-reload-debug
export default {
    name: `cms-block-glyph`,
    components: {CmsComponentGlyph, CmsBlock},
    extends: CmsBlock
}
</script>

<style lang="scss" scoped>
</style>
